import { Tooltip } from "@material-ui/core";
import { I18n } from "aws-amplify";

function UserTagPrivateBookmarkCount({ticketKnowledge}) {
    return (
        <div className='bookmark-count'>
            <Tooltip
                title={`${I18n.get('PRIVATE_BOOKMARK_TOTAL')}`}
                placement="top"
                arrow={true}
            >
                <img src='/assets/image/icon-bookmark.svg' alt='icon-bookmark' className='knowledge-icon-frame-size'/>
            </Tooltip>
            <span className='bookmark-count-number'>
                {ticketKnowledge.totalPrivateBookmark > 0
                    ? ticketKnowledge.totalPrivateBookmark >= 100 ? '99+' : ticketKnowledge.totalPrivateBookmark
                    : '0'
                }
            </span>
        </div>
    );
}

export default UserTagPrivateBookmarkCount;